import { environment } from "../../config";
import { DBComponente } from "../../interfaces/SuperAdmin/Others/iDataComponentes";
import { iDataEstado } from "../../interfaces/SuperAdmin/Others/iDataEstado";
import { iDataPaises } from "../../interfaces/SuperAdmin/Others/iDataPaises";
import { iTipoObjetivo } from "../../interfaces/SuperAdmin/Others/iDataTipoObjetivos";
import { iDataTiposPlan } from "../../interfaces/SuperAdmin/Others/iDataTipoPlanes";
import { fetchData } from "./httpClient";

const { REACT_APP_API_CONTROL_TRANSACCIONAL } = environment;
const baseApiBroker = REACT_APP_API_CONTROL_TRANSACCIONAL;

export const getAllPaises = () =>
  fetchData<iDataPaises[]>({
    method: "GET",
    url: `${baseApiBroker}/pais`,
  });

export const getAllEstados = () =>
  fetchData<iDataEstado[]>({
    method: "GET",
    url: `${baseApiBroker}/estado`,
  });

export const getAllPlanTypes = () =>
  fetchData<iDataTiposPlan[]>({
    method: "GET",
    url: `${baseApiBroker}/tipo-plan`,
  });

// Temporalmente se hará que el tipo sea DBComponente hasta que se cambie el auth de Daniel
export const getAllComponents = () =>
  fetchData<DBComponente[]>({
    method: "GET",
    url: `${baseApiBroker}/componente`,
  });

export const getAllObjectiveTypes = () =>
  fetchData<iTipoObjetivo[]>({
    method: "GET",
    url: `${baseApiBroker}/tipo-objetivo`,
  });
